/**
 *  PRODUCT JS
 *  modify
 */
import ProductModal from './components/product/ProductModal';
import Vue from 'vue';

Vue.component('product-modal', ProductModal);



$(document).ready(function () {
    function trans(translation) {
        var language = document.documentElement.lang;

        return _.get(window.i18n, language + "." + translation);
    }

    if (document.getElementById('article_reorder')) {
        //alert("start");
        /* create products */
        var modal = document.getElementById("myModal");

        var span = document.getElementsByClassName("close")[0];
        var productModal = document.getElementById("productModal");


        span.onclick = function () {
            modal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target == productModal) {
                productModal.style.display = "none";
            }
            if(event.target == modal){
                modal.style.display = "none";
            }
        };

        $('td.clickable').on('click', function () {
           // alert($(this).data('id'));




            if (confirm(trans('page.product.view.edit_product_q'))) {
                vue.$refs["product-modal"].loadProduct($(this).data('id'));
                productModal.style.display = "block";
            } else {
            }
        });

    }
    if (document.getElementById('report_hidden')) {
        //alert("start");
        /* create products */
        var modal = document.getElementById("myModal");

        var span = document.getElementsByClassName("close")[0];
        var productModal = document.getElementById("productModal");


        span.onclick = function () {
            modal.style.display = "none";
        };
        window.onclick = function (event) {
            if (event.target == productModal) {
                productModal.style.display = "none";
            }
            if(event.target == modal){
                modal.style.display = "none";
            }
        };

        $('td.clickable').on('click', function () {
           // alert($(this).data('id'));




            if (confirm(trans('page.product.view.edit_product_q'))) {
                vue.$refs["product-modal"].loadProduct($(this).data('id'));
                productModal.style.display = "block";
            } else {
            }
        });

    }
});